import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-landing-page-header",
  templateUrl: "./landing-page-header.component.html",
  styleUrls: ["./landing-page-header.component.css"],
})
export class LandingPageHeaderComponent {
  @Output() navigationClick = new EventEmitter<string>();
  @Output() loginClick = new EventEmitter<void>();

  mobileMenuOpen = false;

  onNavigationClick(section: string): void {
    this.mobileMenuOpen = false;
    this.navigationClick.emit(section);
  }

  onLoginClick(): void {
    this.loginClick.emit();
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
